import { useEffect, useState } from "react";

const STORAGE_KEY = "hl-theater-watchlist";

const readWatchlist = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === "string") : [];
  } catch {
    return [];
  }
};

export default function WatchlistButton({ dramaId, title }: { dramaId: string; title: string }) {
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    setTracked(readWatchlist().includes(dramaId));
  }, [dramaId]);

  const toggle = () => {
    const list = readWatchlist();
    const next = list.includes(dramaId) ? list.filter((id) => id !== dramaId) : [...list, dramaId];
    setTracked(next.includes(dramaId));
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* 存储不可用时仅保留当前状态 */
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={tracked}
      aria-label={`${tracked ? "移出" : "加入"}追剧清单：${title}`}
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-label font-medium transition-colors cursor-pointer ${
        tracked
          ? "bg-accent-500 text-background-950 hover:bg-accent-400"
          : "bg-primary-500 text-background-950 hover:bg-primary-400"
      }`}
    >
      <i className={tracked ? "ri-bookmark-fill" : "ri-bookmark-line"} aria-hidden="true"></i>
      {tracked ? "已加入追剧清单" : "加入追剧清单"}
    </button>
  );
}